
<BasicConfigurator :value="imagesForBasicConfigurator"
                   :product="product"
                   :configuration-valid="value.length > 0"
                   :choices="prefill && prefill.choices"
                   @addedToBasket="onAddedToBasket"
                   @backToProducts="$emit('backToProducts')"
                   @error="onError"
                   @reset="resetConfiguration"
>
  <v-row v-if="!basketProductSubmission || !basketProductSubmission.editing" dense>
    <v-col cols="auto">
      <v-switch v-model="selectMultiple" :label="$t('CONFIGURATOR_CHOOSE_MULTIPLE')" class="multipleSwitch"/>
    </v-col>
    <v-col cols="auto" class="help-tooltip-container">
      <HelpTooltip inline>{{ $t("CONFIGURATOR_CHOOSE_MULTIPLE_HINT") }}</HelpTooltip>
    </v-col>
  </v-row>
  <ImageSelector :value="selectedImageOrImages"
                 :images="eligibleImages"
                 :product-id="product.id"
                 :multiple="selectMultiple"
                 :filter="product.imageFilter"
                 @input="onSelect"/>
</BasicConfigurator>
